import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { JobSubTrainings } from '../../components/details/JobSubTrainings';
import { IJobDetailsService } from '../../jobDetails.service';
import { withValidType } from './withValidType';

export const JobSubTrainingJobsContainer = withValidType(
  observer((): ReactElement => {
    const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
    const overlayLoader = useInjection(IOverlayLoaderStore.$);
    const jobDetailsService = useInjection(IJobDetailsService.$);

    return (
      <JobSubTrainings
        trainingJobs={jobDetailsService.store.trainingJobs}
        workspaceId={currentWorkspaceStore.currentWorkspace.id}
        isLoading={overlayLoader.isSpinnerVisible('job-training-jobs-table')}
      />
    );
  })
);
